import { render } from "./BomHeaderTag.vue?vue&type=template&id=48330210"
import script from "./BomHeaderTag.vue?vue&type=script&lang=js"
export * from "./BomHeaderTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__